import React from 'react';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import Box from '@amzn/awsui-components-react/polaris/box';
import Spinner from '@amzn/awsui-components-react/polaris/spinner';
import { useAnalyticsData } from '../../../hooks';

const UsageChart: React.FC = () => {
  const { data, loading, error } = useAnalyticsData();

  if (loading) {
    return (
      <Container>
        <Box textAlign="center" padding="l">
          <Spinner />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Box color="text-status-error" textAlign="center" padding="l">
          Error loading usage data
        </Box>
      </Container>
    );
  }

  return (
    <Container
      header={
        <Header variant="h2">
          Usage Trends
        </Header>
      }
    >
      <Box padding="l">
        {data && data.dailyMetrics && data.dailyMetrics.length > 0 ? (
          <div>
            <Box variant="awsui-key-label">Recent Activity</Box>
            {data.dailyMetrics.slice(-7).map((day) => (
              <Box key={day.date} margin={{ vertical: 'xs' }}>
                <strong>{day.date}</strong>: {day.transcriptionJobs} jobs, {day.uniqueUsers} users
              </Box>
            ))}
          </div>
        ) : (
          <Box textAlign="center" color="text-status-inactive">
            No usage data available
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default UsageChart;
